<div class="sky-card">
  <div class="sky-card-body">
    <app-clock></app-clock>
  </div>
</div>

@if (wikiBannerAvailable && !wikiBannerDismissed) {
  <div class="sky-card mt">
    <div class="sky-card-body">
      <div class="container">
        <div class="flex-banner">
          <img class="banner-img" src="/assets/external/wiki-site-logo.webp" alt="Sky Wiki" style="float:left;">
          <div class="banner-text">
            <h4>Let your honks be heard!</h4>
            <p>
              The Sky Wiki is celebrating its 5th anniversary of soaring in the Sky with players like you, and they are conducting a survey to gather your experience and usage of the Sky Wiki!
              Sky Planner uses the Sky Wiki as an important source of information and images that you see here.
            </p>
            <p>Whether you're a seasoned shepherd, or a newcomer moth who has never used the Sky Wiki, your feedback will be greatly appreciated. It will take under 10 minutes to complete.
              This survey will be open from June 9th, to July 9th 2024.</p>
            <div class="mt-half">
              <a href="https://bit.ly/SPSkyWikiSurvey" class="button banner-cta">
                <mat-icon class="menu-icon">edit_note</mat-icon>
                <span class="menu-label">Go to survey</span>
              </a>
            </div>
          </div>
        </div>
        <div class="banner-close">
          <button type="button" (click)="dismissWikiBanner()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
}

<div class="mt">
  <app-search></app-search>
</div>

<div class="sky-card mt" *ngIf="!season && !eventInstances.length && !ts">
  <div class="sky-card-body">
    <div class="container">
      There is currently no season or event active.<br/>
      You can view items, seasons, events and more in the menu on the left.
    </div>
  </div>
</div>

<app-dashboard-wishlist [season]="season" [eventInstances]="eventInstances" [ts]="ts" [rs]="rs"></app-dashboard-wishlist>

<div class="grid grid-2 mt">
  <!-- Ongoing -->
  <app-season-card *ngIf="season" [season]="season" [options]="{show: ['img', 'overview', 'date', 'checkin', 'calculator', 'cost']}"></app-season-card>
  <ng-container *ngFor="let eventInstance of eventInstances">
    <app-event-card *ngIf="eventInstance" [event]="eventInstance.event" [instance]="eventInstance" [options]="{show: ['img', 'overview', 'date', 'checkin', 'calculator', 'cost']}"></app-event-card>
  </ng-container>
  <app-spirit-card *ngIf="ts" [spirit]="ts.spirit" [ts]="ts" [tree]="ts.tree" [options]="{homeBackground: true, show: ['img', 'ts', 'cost']}">
    <div title><h2 class="h3 mb-0">Traveling Spirit <span class="c-accent h4">(#{{ts.number}})</span></h2></div>
  </app-spirit-card>
  <app-returning-spirit-card *ngIf="rs" [return]="rs"></app-returning-spirit-card>
  <!-- Future -->
  <app-season-card *ngIf="!season && futureSeason" [season]="futureSeason" [options]="{show: ['img', 'overview', 'date', 'checkin', 'cost']}"></app-season-card>
  <app-event-card *ngIf="futureEventInstance" [event]="futureEventInstance.event" [instance]="futureEventInstance" [options]="{show: ['img', 'overview', 'date', 'checkin', 'cost']}"></app-event-card>
  <app-spirit-card *ngIf="futureTs" [spirit]="futureTs.spirit" [ts]="futureTs" [tree]="futureTs.tree" [options]="{homeBackground: true, show: ['img', 'ts', 'cost']}">
    <div title><h2 class="h3 mb-0">Traveling Spirit <span class="c-accent h4">(#{{futureTs.number}})</span></h2></div>
  </app-spirit-card>
  <app-returning-spirit-card *ngIf="futureRs" [return]="futureRs"></app-returning-spirit-card>
</div>

